import { render, staticRenderFns } from "./solicitudes_por_comprar_invitado.vue?vue&type=template&id=61d9cd44"
import script from "./solicitudes_por_comprar_invitado.vue?vue&type=script&lang=js"
export * from "./solicitudes_por_comprar_invitado.vue?vue&type=script&lang=js"
import style0 from "./solicitudes_por_comprar_invitado.vue?vue&type=style&index=0&id=61d9cd44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports